<template>
  <Sales
    :items="elements"
    :loading="loading && isEmpty"
    @reached-bottom="loadMore"
    @client-clicked="goToClient($event)"
  />
</template>

<script>
import Sales from './Sales';
import Listable from '../mixins/listable';

export default {
  name: 'SalesContainer',
  components: {
    Sales,
  },
  mixins: [Listable],
  props: {
    source: {
      type: String,
      default: 'transactions',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
  },
  computed: {
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
    profiles() {
      // Profiles are already fetched by sibling component
      if (!this.isAdminMode) {
        return [];
      }
      return this.$store.state.profiles.items;
    },
    isEmpty() {
      return this.elements.length === 0;
    },
  },
  mounted() {
    this.queryParams.scope = this.$store.getters['account/scope'];

    // TODO:  an improvement based on eyeballing SaleTransactionViewSet.get_queryset()?
    //
    //        vary on 'role' & 'team-id' & 'institution-id' should cover all the cases
    //        instead of the naive cache-by-user-id here!  easier invalidation too!!
    //
    this.queryParams.cacheVaryOnUserId = this.$store.state.account.user.profile.pk;
  },
  methods: {
    goToClient(clientId) {
      this.$router.push(`/clients/${clientId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
